<template>
  <highliter
    v-model="section.name"
    section-type="element"
    class="highlight-element"
    :dublicate-deep="parentUID"
    :dublicate="section"
    :hide-bar="hideBar"
    :hide-add="hideAdd"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @dublicate="$emit('dublicate')"
    @delete="onDelete"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('chat')"
  >
    <div
      :data-sid="section.sid"
    >
      <div
        ref="chatEl"
        class="es-live-chat overflow-hidden"
        :class="[`--${section.sid}--chat`, {'element-hidden': !visability()}]"
      >
        <div class="info">
          <div class="flex items-center info-title">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 8H20C20.5523 8 21 8.44772 21 9V20L17.6667 17.2308C17.4872 17.0817 17.2611 17 17.0277 17H9C8.44771 17 8 16.5523 8 16V13"
                stroke="#3D82EA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15 4H4C3.44772 4 3 4.44772 3 5V16L6.33329 13.2308C6.51283 13.0817 6.73889 13 6.97231 13H15C15.5523 13 16 12.5523 16 12V5C16 4.44772 15.5523 4 15 4Z"
                stroke="#3D82EA"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Live Chat
          </div>
        </div>
        <div class="online-status flex items-center w-100">
          {{ online }} Currently Online
          <div class="cursor-pointer ml-auto">
            Logout
          </div>
        </div>
        <div
          v-show="section.options.content.pinnedMessage"
          class="pinned-message"
          v-html="section.options.content.pinnedMessage"
        />
        <div
          v-show="section.options.content.showLogin"
          class="chat-box chat-login flex-column justify-content-center flex text-center"
        >
          <div class="chat-login-title">
            Log in to Live Chat!
          </div>
          <form>
            <input
              v-model="login.name"
              type="text"
              required
              placeholder="Enter name..."
              class="chat-login-field"
            >
            <input
              v-model="login.email"
              type="email"
              required
              placeholder="Enter Email Address..."
              class="chat-login-field"
            >
            <button
              type="submit"
              class="chat-login-button mb-2 transition-opacity hover:opacity-80 overflow-clip"
              @click.stop
            >
              <div class="form-icon">
                <i class="fa fa-user form-social-icon opacity-80" />
              </div>
              Login as Guest
            </button>
            <button
              type="button"
              class="chat-login-button mb-2 transition-opacity hover:opacity-80 overflow-clip"
              @click.stop
            >
              <div class="form-icon">
                <img
                  v-if="section.options.content?.image?.src"
                  class="estage-icon"
                  :src="section.options.content.image.src"
                  alt="ESTAGE Logo"
                >
                <i
                  v-else
                  class="fa fa-users form-social-icon opacity-80"
                />
              </div>
              {{ section.options.content.loginText }}
            </button>
          </form>
        </div>
        <div
          v-if="!section.options.content.showLogin"
          class="chat-box messages"
        >
          <template v-if="!messages.length">
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> Lorem ipsum dolor sit amet, consectetur adipisicing elit...
                </div>
              </div>
            </div>
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> Lorem ipsum dolor sit amet, consectetur.
                </div>
              </div>
            </div>
            <div>
              <div class="message replied flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> @Usernane, Lorem ipsum dolor sit amet, consectetur.
                </div>
              </div>
            </div>
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span>
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit 😃
                </div>
              </div>
            </div>
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> Lorem ipsum dolor 😄 😍 💗
                </div>
              </div>
            </div>
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> Lorem ipsum dolor sit amet, consectetur adipisicing elir ....
                </div>
              </div>
            </div>
            <div>
              <div class="message flex">
                <img
                  class="user-avatar"
                  src="https://gravatar.com/avatar/6ef803b24975a2455543d40f3f0d9f8d"
                  alt="Avatar"
                >
                <div class="msg">
                  <span class="message-user-name cursor-pointer">Demo User</span> Lorem ipsum dolor sit amet, consectetur.
                </div>
              </div>
            </div>
          </template>
          <div
            v-for="message in messages"
            :key="message.id"
          >
            <div class="message flex">
              <div class="relative">
                <img
                  class="user-avatar mt-[2px]"
                  :src="message.avatar || gravatarUrl(message.email)"
                  :alt="message.name"
                >
              </div>
              <div class="msg">
                <div class="flex gap-1">
                  <span class="message-user-name cursor-pointer">{{ message.username }}</span>
                </div>

                {{ message.text }}
              </div>
            </div>
          </div>
        </div>
        <div class="composer-wrapper">
          <form class="position-relative">
            <input
              class="composer"
              placeholder="Type a message..."
              maxlength="100"
              required=""
              type="text"
            >
            <div class="v3-input-picker-icon">
              😄
            </div>
            <button
              class="submit-button"
              type="submit"
            >
              <i class="fa-regular fa-paper-plane" />
            </button>
          </form>
        </div>
        <div class="d-none ban-message" />
      </div>
    </div>
  </highliter>
</template>

<script>
import _ from 'lodash'
import {mapMutations, mapState} from 'vuex'
// import Badges from '@/components/builder/components/badges/Index.vue'
import SectionMixin from '@builder/components/mixins/SectionMixin'
import Highliter from '@builder/components/builder/utils/Highliter'
import gravatar from 'gravatar'
import {createProjectLiveChatService} from '@/services/liveChat'
import {supabase} from '@/supabase'
import {mapChatMessage} from '@/utils/supabase-realtime'
import {buildPagePresenceId, subscribeToPagePresence} from '@/utils/page-presence'
// import ProfilePreview from '@/components/builder/components/badges/profile/Preview.vue'
// import ProfileExp from '@/components/builder/components/badges/profile/Exp.vue'

export default {
  name: 'ElRealtimeChat',
  components: {
    // ProfileExp,
    // ProfilePreview,
    // Badges,
    Highliter
  },
  mixins: [SectionMixin],
  data () {
    return {
      online: 0,
      messages: [],
      unsubMessages: null,
      unsubOnline: null,
      isLoading: true,
      badges: [],
      group: {},
      login: {
        name: '',
        email: ''
      }
    }
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user
    }),
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapState('pages', {
      page: state => state.page,
      currentPage: state => state.currentPage
    }),
    presencePageId () {
      return buildPagePresenceId(
        this.project?.id,
        this.page?.id || this.currentPage?.id,
        'builder-preview'
      )
    },
    roomID () {
      return this.section.options.content.chat.roomID
    }
  },
  methods: {
    ...mapMutations('liveStream', {
      SET_ROOM_ID: 'SET_ROOM_ID'
    }),
    async initializeChat () {
      if (!this.roomID || !supabase) {
        this.isLoading = false
        return
      }
      this.SET_ROOM_ID(this.roomID)
      await this.setupMessageListener()
      this.setupOnlineCounter()

      this.isLoading = false
    },
    async setupMessageListener () {
      const {data} = await supabase
        .from('public_chat_messages')
        .select('*')
        .eq('room_id', this.roomID)
        .order('created_at', {ascending: false})
        .limit(100)

      this.messages = (data || []).reverse().map(mapChatMessage)

      const channel = supabase
        .channel(`builder-chat-messages:${this.roomID}`)
        .on('postgres_changes', {
          event: 'INSERT',
          schema: 'public',
          table: 'public_chat_messages',
          filter: `room_id=eq.${this.roomID}`
        }, ({new: row}) => {
          this.handleNewMessages([mapChatMessage(row)])
        })
        .subscribe()

      this.unsubMessages = () => {
        supabase.removeChannel(channel)
      }
    },
    handleNewMessages (newMessages = []) {
      if (newMessages.length) {
        this.messages = [...this.messages, ...newMessages]
          .slice(-100)
          .filter((msg, index, self) =>
            index === self.findIndex(m => m.id === msg.id)
          )
      }
    },
    setupOnlineCounter () {
      this.unsubOnline?.()

      this.unsubOnline = subscribeToPagePresence({
        supabase,
        pageId: this.presencePageId,
        userId: this.user?.id?.toString() || this.roomID,
        onUpdate: (count) => {
          this.online = count
        }
      })
    },
    gravatarUrl (email) {
      return gravatar.url(email)
    },
    onDelete () {
      this.$emit('delete')
    },
    async scrollChat () {
      await this.$nextTick()
      const chatBoxEl = this.$refs.chatEl?.querySelector('.chat-box.messages')
      if (chatBoxEl) {
        const isScrolledToBottom = (chatBoxEl.scrollTop + chatBoxEl.clientHeight + (chatBoxEl.clientHeight / 2)) >= chatBoxEl.scrollHeight
        if (isScrolledToBottom) {
          chatBoxEl.scrollTop = chatBoxEl.scrollHeight
        }
      }
    }
  },
  watch: {
    messages (val) {
      if (val.length) {
        _.throttle(this.scrollChat, 300)()
      }
    }
  },
  async created () {
    this.$set(this.section.options.content, 'showLogin', false)
    if (!this.section.options.content.loginText) {
      this.$set(this.section.options.content, 'loginText', 'Login as Community Member')
    }
    if (!this.section.options.content.image) {
      this.$set(this.section.options.content, 'image', {})
    }
    if (!this.section.options.content.chat?.roomID) {
      const data = await createProjectLiveChatService({
        project: this.project
      }).createRoom({
        hash: this.user.hash,
        userId: this.user.id
      })
      this.$set(this.section.options.content.chat, 'roomID', data.id)
      await this.initializeChat()
    } else {
      try {
        await createProjectLiveChatService({
          project: this.project
        }).ensureRoomExists({
          roomId: this.roomID,
          hash: this.user.hash,
          userId: this.user.id
        })
      } catch (e) {
        console.warn('[RealtimeChat] Failed to ensure room exists in Supabase', e)
      }
      await this.initializeChat()
    }
  },
  beforeDestroy () {
    if (this.unsubMessages) {
      this.unsubMessages()
    }
    if (this.unsubOnline) {
      this.unsubOnline()
    }
  }
}
</script>

<style lang="scss">
.profile-exp {
  position: absolute;
  right: -20px;
  bottom: -8px;
  z-index: 10;
}

.estage-icon {
  width: 24px;
  height: 24px;
}

.es-live-chat {
  display: flex;
  flex-direction: column;
  height: 600px;
  --height: 600px;
  background-color: #F2F5FA;

  .info {
    padding: 15px 23px;

    .info-title {
      gap: 7px;
      color: #000;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;

      svg path {
        stroke: #3D82EA;
      }
    }
  }

  .online-status {
    background-color: rgba(242, 245, 250, 1);
    color: #3D82EA;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    padding: 8px 24px;
  }

  .pinned-message {
    background-color: #F2F5FA;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 15px;
    padding: 8px 24px;

    p {
      margin-bottom: 0 !important;
    }
  }

  .ban-message {
    text-align: center;
    padding: 30px;
    font-size: 14px;
    color: #000;
  }

  .chat-box {
    background-color: #fff;
    overflow: auto;
    padding: 25px 0;
    height: 100%;

    .message {
      gap: 10px;
      padding: 10px 20px;

      .user-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50px;
      }

      .message-user-name {
        color: #3D3D3D;
        font-size: 12px;
        font-weight: 700;
        margin-right: 2px;
      }

      .msg {
        white-space: pre-line;
        font-size: 12px;
        color: #717171;
        text-align: left;

        &.with-date {
          padding-right: 35px;
        }
      }
    }

    &.chat-login {
      form {
        padding: 20px;

        input {
          background-color: #f2f5fa;
          height: 48px;
          width: 100%;
          margin-bottom: 9px;
          padding: 0 15px;
        }

        button {
          position: relative;
          color: #666666;
          font-size: 14px;
          font-weight: 400;
          background-color: #f2f5fa;
          height: 48px;
          width: 100%;

          i {
            position: absolute;
            left: 0;
            top: 0;
            padding: 16px;
          }
        }
      }
    }

    &.disabled-chat {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: #717171;
      font-size: 12px;

      svg {
        margin-bottom: 15px;
      }
    }
  }

  .composer-wrapper {
    background-color: #F2F5FA;
    padding: 20px 18px;

    .submit-button {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
      background: transparent;
      padding: 0;

      i {
        color: #005CE8;
        font-size: 16px;
      }
    }

    .composer {
      height: 48px;
      --height: 48px;
      padding: 0 20px;
      width: 100%;
      padding-right: 75px;

      &::placeholder {
        color: #8a8d90;
        font-size: 16px;
      }
    }
  }
}

.es-live-chat-fixed {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 300px;
  z-index: 1000;

  .chat-box {
    height: calc(100% - 200px);
  }
}

.form-social-icon {
  width: 50px;
  height: 50px;
}

.form-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 100%;
  background-color: #e2e6ee;
  display: flex;
  justify-content: center;
  align-items: center;
}

.estage-icon {
  width: 24px;
  height: 24px;
}

.v3-input-picker-icon {
  top: 50% !important;
  font-size: 20px;
  transform: translateY(-50%);
  right: 40px !important;
  position: absolute !important;
}
</style>
